import { TranslationItemModel } from '@/shared/api/BaseAPI.model'

type AllergenModel = {
  id: string
  iconUrl: string
  translations: TranslationItemModel[]
}

type AllergensResponseModel = AllergenModel[]

type UnitModel = {
  id: string
  translations: TranslationItemModel[]
  type: 'count' | 'weight' | 'volume'
}

type UnitsResponseModel = UnitModel[]

type DietsModel = {
  id: string
  translations: TranslationItemModel[]
}

type DietsResponseModel = DietsModel[]

type IngredientModel = {
  id: string
  translations: TranslationItemModel[]
  allergenIds: string[]
  unitId: string
  quantity: number
  pricePerUnit: {
    unitId: string
    price: number
  }
}

type IngredientsResponseModel = IngredientModel[]

type IngredientPayloadModel = {
  translations: TranslationItemModel[]
  allergenIds: string[]
  unitId: string
  quantity: number
  pricePerUnit: {
    unitId: string
    price: number
  }
}

enum QUERY {
  INGREDIENTS = 'ingredients',
  ALLERGENS = 'allergens',
  UNITS = 'units',
  DIETS = 'diets'
}
export { QUERY }
export type {
  IngredientModel,
  IngredientPayloadModel,
  IngredientsResponseModel,
  AllergensResponseModel,
  DietsResponseModel,
  UnitsResponseModel,
  AllergenModel,
  UnitModel
}
